<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardAccountantInfo'}"
          :class="{ active: $route.name === 'dashboardAccountantInfo' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardAccountantChartOverview' }"
          :class="{ active: $route.name === 'dashboardAccountantChartOverview' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.overviews') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardAccountantPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardAccountantPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>

<style scoped>

</style>